import DayNames from '@/constants/date/DaysOfWeekString'
import TimeRangeTypes from '@/constants/schedule/ScheduleTimeTypes'
import ScheduleScopes from '@/constants/schedule/ScheduleScopes'
import ScheduleTimeDTO from './scheduleTimeDTO'

/**
 * Data Transfer Object for updating a work schedule
 * @param {number} locationId - The ID of the location
 * @param {Object} scheduleTimes - The schedule times to update (e.g., { monday: ScheduleTimes, tuesday: ScheduleTimes, ... })
 * @param {Array} removedDays - The days to remove from the schedule (e.g., ['monday', 'tuesday'])
 */
export default class WorkScheduleUpdateDTO {
  constructor(locationId, scheduleTimes, removedDays = []) {
    this.scheduleScope = ScheduleScopes.location
    this.id = locationId
    this.scheduleTimes = scheduleTimes
      ? _processScheduleTimes(scheduleTimes, removedDays)
      : []
  }

  get isValid() {
    return this.scheduleTimes.every(
      (item) => item.startTimeLocal && item.endTimeLocal
    )
  }
}

/**
 * Processes the schedule times to create ScheduleTimeDTO objects
 * @param {Object} scheduleTimes - The schedule times to process
 * @param {Array} removedDays - The days to remove from the schedule
 * @returns {Array} The processed schedule times
 */
function _processScheduleTimes(scheduleTimes, removedDays) {
  const processedTimes = []

  DayNames.forEach((day) => {
    if (removedDays.includes(day)) return

    const { standardHours, standardBreak } = scheduleTimes[day]

    processedTimes.push(
      new ScheduleTimeDTO(
        TimeRangeTypes.standardHours,
        day,
        standardHours.startTime,
        standardHours.endTime
      )
    )
    processedTimes.push(
      new ScheduleTimeDTO(
        TimeRangeTypes.standardBreak,
        day,
        standardBreak.startTime,
        standardBreak.endTime
      )
    )
  })
  return processedTimes
}
